import { useState, type ReactNode } from "react"

import { HoverCard, HoverCardContent, HoverCardTrigger } from "./HoverCard"
import { cn } from "../lib/cn"
import * as Icones from "./Icones"

const FOCO =
  "focus-visible:rounded-[2px] focus-visible:outline-2 focus-visible:outline-offset-2! focus-visible:outline-(--acao)"
const TEXTO = `cursor-help underline decoration-dotted underline-offset-3 ${FOCO}`
const SEM_SUBLINHADO = `cursor-help ${FOCO}`
const ICONE = `inline-flex cursor-help align-middle text-(--tinta-3) no-underline hover:text-(--acao) ${FOCO}`

export function ComDica({
  dica,
  children,
  foraDoTab = false,
  semSublinhado = false,
  classe,
}: {
  dica: string | null | undefined
  children?: ReactNode
  foraDoTab?: boolean
  semSublinhado?: boolean
  classe?: string
}) {
  const [aberta, definirAberta] = useState(false)
  if (dica === null || dica === undefined || dica === "") return <>{children}</>
  const soIcone = children === undefined
  return (
    <HoverCard openDelay={0} open={aberta} onOpenChange={definirAberta}>
      <HoverCardTrigger asChild>
        <span
          data-slot="com-dica"
          tabIndex={foraDoTab ? undefined : 0}
          className={cn(soIcone ? ICONE : semSublinhado ? SEM_SUBLINHADO : TEXTO, classe)}
          onClick={() => definirAberta(!aberta)}
        >
          {children ?? <Icones.Informacao />}
          <span className="sr-only">{soIcone ? dica : `. ${dica}`}</span>
        </span>
      </HoverCardTrigger>
      <HoverCardContent collisionPadding={16}>
        <p className="m-0 text-(length:--texto-sm) font-normal text-(--tinta-2)">{dica}</p>
      </HoverCardContent>
    </HoverCard>
  )
}
